import React, { useState, useEffect } from 'react';
import { Form, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLifestyleCategoriesI18n } from '../utils/lifestyleCategoriesI18n';
import LifestyleCategoryFormI18n from './intake/LifestyleCategoryFormI18n';

const PatientIntakeEnvironment = ({ sessionId, initialData, onSave, onSubmit, onPrevious }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation();

  // Get environment category from i18n-enabled lifestyle categories
  const lifestyleCategories = useLifestyleCategoriesI18n();
  const environmentCategory = lifestyleCategories.find(cat => cat.key === 'environment');

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      form.setFieldsValue(initialData);
    }
  }, [initialData, form]);

  const handleSave = async (values) => {
    setLoading(true);
    // Include category indicator to mark this section as completed
    const dataWithCategory = {
      ...values,
      _completedCategory: 'environment'
    };
    const success = await onSave(dataWithCategory);
    setLoading(false);
    return success;
  };

  const handleFinish = async (values) => {
    const success = await handleSave(values);
    if (success) {
      onSubmit();
    }
  };

  const handleSaveAndContinue = async () => {
    try {
      const values = form.getFieldsValue(); // Get values without validation since all questions are optional
      await handleSave(values);
    } catch (error) {
      console.error('Save failed:', error);
      message.error('Failed to save progress. Please try again.');
    }
  };

  const handlePrevious = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onPrevious();
  };

  const handleFinalSubmit = async () => {
    setSubmitting(true);
    try {
      const values = form.getFieldsValue(); // Get values without validation since all questions are optional
      const success = await handleSave(values);
      if (success) {
        onSubmit();
      }
    } catch (error) {
      console.error('Submit failed:', error);
      message.error('Failed to submit intake. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!environmentCategory) {
    return <div>Error: Environment category not found</div>;
  }

  return (
    <div className="intake-form-section">
      <h3>{t('lifestyle.headers.environmentalFactors')}</h3>
      <p>{t('lifestyle.headers.environmentDescription')}</p>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        autoComplete="off"
        size="large"
      >
        <LifestyleCategoryFormI18n
          category={environmentCategory}
          formName="environment"
        />

        <div className="intake-form-buttons">
          <Button
            onClick={handlePrevious}
            size="large"
          >
            {t('common.previous')}
          </Button>

          <div className="final-buttons">
            <Button
              onClick={handleSaveAndContinue}
              loading={loading}
              size="large"
              style={{ marginRight: 16 }}
            >
              {t('common.save')} Progress
            </Button>

            <Button
              type="primary"
              onClick={handleFinalSubmit}
              loading={submitting}
              size="large"
            >
              {t('common.submit')} Intake
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default PatientIntakeEnvironment;
